import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { doc, setDoc } from "firebase/firestore";
import { db as firestoreDb } from "./firebase";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getWhatsAppLink(phone: string, message: string) {
  const cleanPhone = phone.replace(/\D/g, "");
  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
}

function slugify(text: string) {
  return text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "")
    .substring(0, 15); // Shortened name
}

export async function shortenUrl(
  originalUrl: string, 
  shopName?: string, 
  productName?: string,
  imageUrl?: string,
  description?: string,
  twitterCard?: "summary" | "summary_large_image"
): Promise<string> {
  let baseId = "";
  if (shopName) {
    baseId += slugify(shopName);
  }
  if (productName) {
    if (baseId) baseId += "-";
    baseId += slugify(productName);
  }

  // Add a small random suffix to ensure uniqueness and keep it "short"
  const suffix = Math.random().toString(36).substring(2, 5);
  const shortId = baseId ? `${baseId}-${suffix}` : suffix;
  
  const shortUrlRef = doc(firestoreDb, "short_urls", shortId);
  
  try {
    await setDoc(shortUrlRef, {
      id: shortId,
      originalUrl,
      shopName: shopName || null,
      productName: productName || null,
      imageUrl: imageUrl || null,
      description: description || null,
      twitterCard: twitterCard || "summary_large_image",
      createdAt: new Date().toISOString()
    });
    return `${window.location.origin}/s/${shortId}`;
  } catch (error) {
    console.error("Error shortening URL:", error);
    return originalUrl; // Fallback to original
  }
}
